<template>
  <div>
    <el-card class="box-card" body-style="min-height:70vh;">
      <div slot="header" class="clearfix">
        <div class="">
          <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="服务名称：" prop="name">
              <el-input v-model="searchForm.name" placeholder="服务名称搜索" class="mt-search-width"></el-input>
              <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
            </el-form-item>
          </el-form>
          <el-button type="primary" style="margin-left: 12px;" @click="editBtn('')">添加服务</el-button>
        </div>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="serviceName"
            label="服务名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="icon"
            label="图标">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;"
                :src="scope.row.icon == null ? imgServer+'no_img.png' : scope.row.icon"
                :preview-src-list="[scope.row.icon]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      :title="infoId == '' ? '添加服务' : '编辑服务'"
      :visible.sync="editShow"
      width="960px">
      <el-form :model="editForm" :inline="false" label-width="140px">
        <el-form-item label="服务名称：" prop="serviceName">
          <el-input style="width: 424px;" v-model="editForm.serviceName" placeholder="请输入服务名称"></el-input>
        </el-form-item>
        <el-form-item label="服务图标：" prop="icon">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="1"
            :file-list="fileList"
            :on-remove="delImgBtn"
            :on-success="bannerImgBtn">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">建议尺寸：48*48px，若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="服务内容：" prop="serviceContent">
          <el-input style="width: 424px;" rows="4" v-model="editForm.serviceContent" type="textarea" placeholder="请输入服务内容"></el-input>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <div style="width: 424px;">
            <el-switch v-model="editForm.status">
            </el-switch>
          </div>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input style="width: 424px;" v-model="editForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
        </el-form-item>
        <el-form-item label="  ">
          <div style="width: 424px;">
            <el-button type="primary" @click="saveEditBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryServiceDescPageList, fetchServiceDescDetailById, saveServiceDesc, updateServiceDesc, enableServiceDescById } from '@/api/goods'
export default {
  name: 'ServiceNote',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl: this.$baseUrl,
      token:this.$token,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      infoId: '',
      fullscreenLoading: false,
      searchForm: {
        name: ''
      },
      // 编辑用户
      editShow: false,
      memberInfo: {
        nickName: '',
        phone: '',
        parentNickName: ''
      },
      fileList:[],
      editForm: {
        serviceName: '',
        icon: '',
        serviceContent: '',
        sort: '',
        status: false
      },
      rules: {
        serviceName: [
          { required: true, message: '请输入服务名称', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传服务图标', trigger: 'blur' }
        ],
        serviceContent: [
          { required: true, message: '请输入服务内容', trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    this.getInfoList()
  },
  methods: {
    bannerImgBtn (file) {
      this.editForm.icon = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.editForm.icon = imgUrl;
    },
    /* 编辑用户 */
    editBtn (infoId) {
      var that = this
      that.editForm.serviceName = '';
      that.editForm.icon = '';
      that.fileList = [];
      that.editForm.serviceContent = '';
      that.editForm.sort = '';
      that.editForm.status = false;
      that.infoId = infoId
      if(infoId != ''){
        fetchServiceDescDetailById({ id: infoId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.editShow = true
            that.editForm = data
            if(data.icon != null){
              that.fileList.push({url: data.icon})
            }
            that.editForm.status = data.status == 1 ? true : false
            that.editShow = true;
          }
        })
      }else{
        that.editShow = true;
      }
    },
    /* 编辑用户弹窗-保存 */
    saveEditBtn () {
      var that = this;
      var infoId = that.infoId;
      var editForm = that.editForm;
      var status = that.editForm.status == true ? 1 : 0;
      let sort = that.editForm.sort === '' ? 1 : that.editForm.sort
      if(editForm.serviceName == ''){
        that.$message.error('请输入服务名称');
        return false;
      }
      if(editForm.icon == ''){
        that.$message.error('请上传服务图标');
        return false;
      }
      if(editForm.serviceContent == ''){
        that.$message.error('请输入服务内容');
        return false;
      }
      let passData = {
        serviceName: editForm.serviceName,
        icon: editForm.icon,
        serviceContent: editForm.serviceContent,
        status: status,
        sort: sort
      }
      that.fullscreenLoading = true;
      if(infoId == ''){
        saveServiceDesc(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        passData.id = infoId;
        updateServiceDesc(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this;
      that.fullscreenLoading = false;
      if (res.errorCode === '0000') {
        that.editForm.serviceName = '';
        that.editForm.icon = '';
        that.fileList = [];
        that.editForm.serviceContent = '';
        that.editForm.sort = '';
        that.editForm.status = false;
        that.editShow = false
        that.getInfoList();
      }
      if (res.errorCode === '1001') {
        that.$message.error(res.msg)
      }
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryServiceDescPageList({ serviceName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enableServiceDescById({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeServiceDescById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/ServiceNote.vue